.EventDateTimeLocationSocialsCard {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.EventDateTimeLocation {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5rem;

  & > div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.5rem;

    & > img {
      width: 1rem;
      height: 1rem;
    }
  }
}

.Socials {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5rem;

  & > a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 9999px;
    background-color: var(--bs-gray-200);

    & > img {
      width: 1rem;
      height: 1rem;
    }
  }
}
